import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IGroup } from '@/contracts/system-modules/groups/IGroup'
import { EnumGroupRole } from '@/contracts/system-modules/groups/enum/EnumGroupRole'
import { CreateGroupParams } from '@/system-modules/groups/v1/api/v1/groups/CreateGroup/Dto/CreateGroupParams'

export const OFFLINE_GROUP_UUID = '00000000-0000-4000-8000-000000000002'

export class CreateGroupRoute extends GroupsRoute<CreateGroupParams, IGroup> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/groups'
  }

  /** Без сервера группа создаётся с постоянным UUID */
  offline(params: CreateGroupParams): Promise<ApiResponse<IGroup>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: { uuid: OFFLINE_GROUP_UUID, ownerUuid: '', title: params.title, role: EnumGroupRole.OWNER },
    }))
  }
}
